/* @flow */
export const TIME = Object.freeze({
    sec: 1000,
    min: 60 * 1000,
    hr: 60 * 60 * 1000
});

export default TIME;
